import { BaseAction, State } from './index'

export enum ConfirmPopupActions {
    SET_CONFIRM = 'confirmPopup/SET_CONFIRM',
    CLEAR_CONFIRM = 'confirmPopup/CLEAR_CONFIRM ',
}
export interface ConfirmPopupState {
    show: boolean
    onConfirm?: () => void
    onClose?: () => void
}

const initialState: ConfirmPopupState = {
    show: false,
    onConfirm: () => {
        return
    },
    onClose: () => {
        return
    },
}

export const setConfirmPopup = (payload: ConfirmPopupState) => ({
    payload,
    type: ConfirmPopupActions.SET_CONFIRM,
})
export const clearConfirmPopup = () => ({
    type: ConfirmPopupActions.CLEAR_CONFIRM,
})

export const confirmPopupReducer = (state: ConfirmPopupState = initialState, action: BaseAction) => {
    switch (action.type) {
        case ConfirmPopupActions.SET_CONFIRM: {
            return {
                ...state,
                show: action.payload.show,
                onConfirm: action.payload.onConfirm ? action.payload.onConfirm : initialState.onConfirm,
                onClose: action.payload.onClose ? action.payload.onClose : initialState.onClose,
            }
        }
        case ConfirmPopupActions.CLEAR_CONFIRM: {
            return initialState
        }

        default:
            return state
    }
}

export const selectConFirmPopup = (state: State) => state.confirmPopup
